module.exports = __webpack_public_path__ + "img/36.bd28b6f7.jpg";